import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-inline-error",
    styleUrls: ["./inline-error.component.scss"],
    templateUrl: "./inline-error.component.html",
    standalone: false
})
export class FUIInlineErrorComponent {
    @Input() title: string;
    @Input() titleParams: any = {};
    @Input() message: string;
    @Input() messageParams: any = {};
}
